import comp from "./ShortcutsSection";
export default comp;
